import Network from 'infrastructure/js/modules/network';

export function fetchQpls(query) {
  return Network.post('qpl/items', query);
}

export function createQpl(data) {
  return Network.post('qpl', data);
}

export function editQpl(data) {
  const {id, ...rest} = data;
  return Network.put(`qpl/${id}`, rest);
}

export function updateQplVersion(data) {
  const {id, ...rest} = data;
  return Network.post(`qpl/${id}/version/update`, rest);
}

export function cloneQpl(data) {
  const {id, ...rest} = data;
  return Network.post(`qpl/${id}/clone`, rest);
}

export function removeQpl(id) {
  return Network.delete(`qpl/${id}`);
}

export function activateQpl(id) {
  return Network.post(`qpl/${id}/activate`);
}
export function updateQpls(data) {
  return Network.post('authorized-collaborators/events/supplier/update', data);
}

export function fetchQplsForUpdate(data) {
  return Network.post('authorized-collaborators/events/supplier/entities', data);
}

export function getQpl(id) {
  return Network.get(`qpl/${id}`);
}

export function searchQpls(data) {
  return Network.post('qpl/search/items', data);
}

export function updateMaterialsQplVersion(data) {
  return Network.post('materials/qpl/version/active', data);
}


///// QPL Tests

export function fetchQplTests(qplId, query) {
  return Network.post(`qpl/${qplId}/tests`, query);
}

export function createQplTest(data) {
  const {qplId, ...rest} = data;
  return Network.post(`qpl/${qplId}/test`, rest);
}

export function editQplTest(data) {
  const {id, ...rest} = data;
  return Network.put(`qpl/tests/${id}`, rest);
}

export function cloneQplTest(data) {
  const {id, ...rest} = data;
  return Network.post(`qpl/tests/${id}/clone`, rest);
}

export function getQplTestDetails(qplTestId) {
  return Network.get(`qpl/tests/${qplTestId}`);
}

export function removeQplTests(data) {
  return Network.delete('qpl/tests', data);
}

export function getQplTestOptionalFields(data) {
  return Network.post('qpl/fields', data);
}

export function getQplTestMandatoryFields(data) {
  return Network.post('qpl/testType/fields', data);
}

export function getAllDescriptions() {
  return Network.get('qpl/tests/descriptions');
}

export function createQplTestField(data) {
  return Network.post('qpl/field/custom', data);
}

export function importQplJson(file) {
  return Network.postFile('import/qpl/json/upload', file);
}

export function importQplForMaterialTypeJson(file) {
  return Network.postFile('import/material/qpl/json/upload', file);
}

//-------------QPL Activity Log -------------
export function fetchQplsActivityLog(query) {
  return Network.post('qpl/activities', query);
}
export function fetchQplsPendingRequests(query) {
  return Network.post('coc/acceptance-requests/items', query);
}

//-------------CoC -------------
export function getCoCDetails(cocId) {
  return Network.get(`coc/${cocId}`);
}

export function getCoCTestDetails(cocTestId) {
  return Network.get(`coc/tests/${cocTestId}`);
}

export function fetchCoCTests(coclId, query) {
  return Network.post(`coc/${coclId}/tests`, query);
}

export function saveCoCTest(data, testId) {
  return Network.put(`coc/tests/${testId}`, data);
}

export function getCocAttachmentUrl(attachmentId) {
  return Network.get(`attachments/${attachmentId}/view`);
}

export function setAcceptanceRequest(data) {
  const {setId, ...rest} = data;
  return Network.post(`coc/sets/${setId}/acceptance-request`, rest);
}

export function setAcceptanceDecision(data) {
  const {setId, file, ...rest} = data;
  return Network.postFile(`coc/sets/${setId}/acceptance-decision`, file ,rest);
}

export function fetchAcceptanceDecisions(setId) {
  return Network.get(`coc/sets/${setId}/acceptance-decisions`);
}
